(function () {
  'use strict';
  var d = document;
  function $(s) { return d.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(d.querySelectorAll(s)); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  var main = $('#kpMainImg');
  $$('[data-kp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) main.src = t.getAttribute('data-kp-thumb');
      $$('.kp-thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  var addBtns = $$('[data-kp-add]');
  var stickySizeSel = $('[data-kp-sticky-size]');
  var selected = addBtns[0] ? addBtns[0].getAttribute('data-variant') : null;

  function setVariant(id, priceCents) {
    selected = id;
    addBtns.forEach(function (b) { b.setAttribute('data-variant', id); });
    if (priceCents != null && !isNaN(priceCents)) {
      var p = $('[data-kp-price]'); if (p) p.textContent = money(priceCents);
      var sp = $('[data-kp-sticky-price]'); if (sp) sp.textContent = money(priceCents);
    }
  }

  $$('[data-kp-sizes] .kp-size').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      $$('[data-kp-sizes] .kp-size').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      setVariant(b.getAttribute('data-kp-variant'), parseInt(b.getAttribute('data-price'), 10));
      if (stickySizeSel) stickySizeSel.value = b.getAttribute('data-kp-variant');
    });
  });

  if (stickySizeSel) {
    stickySizeSel.addEventListener('change', function () {
      var id = stickySizeSel.value;
      var btn = d.querySelector('[data-kp-sizes] .kp-size[data-kp-variant="' + id + '"]');
      setVariant(id, btn ? parseInt(btn.getAttribute('data-price'), 10) : null);
      $$('[data-kp-sizes] .kp-size').forEach(function (x) { x.classList.toggle('active', x.getAttribute('data-kp-variant') === id); });
    });
  }

  $$('[data-kp-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      var id = b.getAttribute('data-variant') || selected;
      if (window.kpAddVariant) window.kpAddVariant(id, 1);
    });
  });

  var sticky = $('#kpStickyAtc'), mainAtc = $('.kp-atc [data-kp-add]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var dr = $('#kpDrawer');
      var drawerOpen = dr && dr.classList.contains('open');
      sticky.classList.toggle('show', !e.isIntersecting && !drawerOpen);
    }, { threshold: 0 }).observe(mainAtc);
  }

  var modal = $('#kpSizeModal');
  $$('[data-kp-sizeguide]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.classList.add('open'); }); });
  $$('[data-kp-sizeguide-close]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.classList.remove('open'); }); });
})();
